<template>
  <div>
    <div>
      <vue-cropper
        ref="cropper"
        :src="loadImg"
        :aspect-ratio="300 / 100"
        drag-mode="move"
        alt="Logo a cortar"
        style="width: 570px; height: 300px"
      ></vue-cropper>
    </div>

    <br>
    <div class="vx-row">
      <div class="vx-col sm:w-full lg:w-1/3" >
        <vs-button @click="cropImage" >Aceptar</vs-button>

      </div>
      <div class="vx-col sm:w-full lg:w-1/3" >
        <div class="text-center">
          <vs-button radius color="primary" icon-pack="feather" type="border" class="mr-3 d-inline-block" icon="icon-plus" @click="zoom(0.2)"></vs-button>
          <vs-button radius color="primary" icon-pack="feather" type="border" class="d-inline-block" icon="icon-minus" @click="zoom(-0.2)"></vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-full lg:w-1/3" >
        <vs-button @click="closePopupLogoAdjust" type="flat" class="float-right">Cancelar</vs-button>

      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import 'cropperjs/dist/cropper.min.css';

export default {
  name: "CropperLogo",
  props: [
    'closePopupLogoAdjust', 'loadImg', 'dataImg', 'setDataImgToShow', 'setCroppedImg'
  ],
  components: {
    VueCropper
  },
  mounted() {
    this.$refs.cropper.replace(this.loadImg)
  },
  methods: {
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    cropImage() {
      this.$store.dispatch("alert/clear", {});
      this.$refs.cropper.getCroppedCanvas({
        'width': 300,
        'height': 100
      }).toBlob((blob) => {
        this.setDataImgToShow(this.dataImg)
        this.setCroppedImg(blob)
        this.$store.dispatch("alert/success", "Recortaste la imagen con éxito");
        this.closePopupLogoAdjust();
      })
    }
  }
}
</script>

<style scoped>

</style>
